import * as _ from "../../node_modules/.pnpm/three@0.172.0/node_modules/three/build/three.tsl.js";
import { transformColor as c } from "../../utilities/transformations.js";
import { distort as w } from "../../helpers/distort.js";
import { grain as C } from "../../helpers/grain.js";
import { getAspectCorrectedCoordinates as E } from "../../utilities/uv.js";
const O = {
  name: "Vapor5",
  collection: "vapor",
  tags: ["wave", "gradient", "colorful"],
  props: {
    colorA: {
      type: String,
      default: "#e1b47a",
      transform: c,
      description: "The first color of the vapor wave."
    },
    colorB: {
      type: String,
      default: "#8acab9",
      transform: c,
      description: "The second color of the vapor wave."
    },
    speed: {
      type: Number,
      default: 1,
      description: "The speed of the waves"
    }
  },
  fragmentNode: (o) => {
    const {
      vec4: a,
      uv: m,
      time: l,
      sin: i,
      mix: e,
      abs: p,
      smoothstep: d,
      blendOverlay: f,
      color: r,
      float: n
    } = _, u = 0.1, F = 10, v = 1.1, t = w(m(), 0.1, 1, F), b = i(
      t.y.mul(1.5).mul(Math.PI).sub(l.mul(o.speed.uniform).mul(0.5))
    ).mul(0.2).add(0.5).sub(u), g = e(
      o.colorA.uniform,
      o.colorB.uniform,
      t.x
    ), h = p(t.y.sub(b)).mul(2), s = d(
      n(0.5),
      0,
      h.mul(n(0.5))
    ), { correctedUV: T } = E(), y = C(1)(T), A = g.mul(s).sub(y);
    return f(a(
      e(
        r("#FFFFFF"),
        A,
        s.mul(v)
      ),
      1
    ), r("#FFFFFF"));
  }
};
export {
  O as componentDefinition,
  O as default
};
